import type { ShopperProducts } from '@/scapi';

type CategoryPathNode = {
    id?: string;
    name?: string;
    c_url?: unknown;
    description?: string;
    pageDescription?: string;
    categories?: ShopperProducts.schemas['Category'][];
};

/** Direct child on the current route category (not a URL refine). */
export function findDirectChildCategory(
    parent: ShopperProducts.schemas['Category'],
    childId: string
): ShopperProducts.schemas['Category'] | undefined {
    return parent.categories?.find((child) => child.id === childId);
}

/** Title and description for a category node (route PLP or nested child loaded in the tree). */
export function plpHeaderDisplayForCategoryNode(category: ShopperProducts.schemas['Category']): {
    title: string;
    description: string;
} {
    return {
        title: category.name?.trim() || category.id,
        description: (category.pageDescription || category.description || '').trim(),
    };
}

/** Whether the node already exposes subcategory tag data (vs. show a skeleton while pending). */
export function hasPlpSubcategoryTags(node: CategoryPathNode): boolean {
    return (node.categories?.length ?? 0) > 0;
}
